import { render } from "./FeaturesAndIntegrations.vue?vue&type=template&id=0daeeaac&ts=true"
import script from "./FeaturesAndIntegrations.vue?vue&type=script&lang=ts"
export * from "./FeaturesAndIntegrations.vue?vue&type=script&lang=ts"

import "./FeaturesAndIntegrations.vue?vue&type=style&index=0&id=0daeeaac&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__